import { siteConfig } from '@/configs/siteConfig';

import { getElsDataAttrBlank } from '@/modules/utils/commonUtils';

const props = {
  className: 'js-tab',
  duration: '.8s',
} as const;

const state = {};

export const tabManager = {
  init() {
    this.setupClick();
  },

  setupClick() {
    const tabEls = Array.from(document.querySelectorAll(`.${props.className}`)) as HTMLElement[];
    tabEls.forEach((tabEl) => {
      const btnEls = Array.from(tabEl.querySelectorAll('button')) as HTMLButtonElement[];
      const groupName = tabEl.dataset.tab;
      const groupEls = groupName ? (Array.from(document.querySelectorAll(`[data-tab-group="${groupName}"]`)) as HTMLElement[]) : getElsDataAttrBlank('tab-group');

      btnEls.forEach((btnEl) => {
        btnEl.addEventListener('click', (e) => {
          e.preventDefault();
          const targetId = btnEl.dataset.target;
          if (!targetId) {
            console.warn('[tabManager] data-target 属性が存在しないか、空です', btnEl);
            return;
          }

          btnEls.forEach((el) => el.classList.remove(siteConfig.class.act));
          btnEl.classList.add(siteConfig.class.act);

          groupEls.forEach((el) => {
            el.style.display = 'none';

            // 初期表示用のclassを外すため
            el.classList.remove(siteConfig.class.act);
          });

          const targetEls = document.querySelectorAll<HTMLElement>(`[data-id="${targetId}"]`);
          if (!targetEls) {
            console.warn(`[tabManager] セレクタ "[data-id="${targetId}"]" に該当する要素が見つかりません`, btnEl);
            return;
          }

          targetEls.forEach((el) => {
            el.style.display = 'block';
            el.style.opacity = '0';
            el.style.transition = `opacity ${props.duration}`;
            requestAnimationFrame(() => {
              el.style.opacity = '1';
            });

            // el.classList.add(siteConfig.class.act);
          });
        });
      });
    });
  },
};
